/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DoneAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function DoneAction({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Footer/DoneAction",
  onClick
  
}) {
let modalLettersValueData = fromData.useDataValue({ viewPath,
context: 'modal',
path: 'letters',
})
let aggregateData = fromHelpers.isDisabled(modalLettersValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 marginLeft={dtSpaceXs}
 onClick={onClick}
 data="modal.letters"
 aggregate="./helpers.js isDisabled"
 disabled={aggregateData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Done"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}